import * as React from 'react';
export const pathwardSvg = React.forwardRef(function pathwardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F1F5F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M29 8.01 18.062 23.314H3.116L29 8.01Z',
      fill: '#2E008B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M29 8H3l12.938 7.773L29 8Z',
      fill: '#8BB8E8',
    }),
  );
});
pathwardSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pathward = {
  category: 'brand',
  colorable: false,
  name: 'pathward',
  svg: pathwardSvg,
};
